import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";
import { FetchDashboardListResData } from "./FetchDashboardListResData";

const ENDPOINT = "/dashboard/";

export class FetchDashboardListCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<FetchDashboardListResData> {
        var res = await this.executeCommand();
        return new FetchDashboardListResData(res);
    }
}
